module.exports = __webpack_public_path__ + "img/Res-Icon-3.a43d45e.png";